import type {
  IOrderMSDocument,
  IOrderMSUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createOrderMSDocument,
  updateDocument: updateOrderMSDocument,
  deleteDocument: deleteOrderMSDocument,
} = makeDocumentService<IOrderMSDocument, IOrderMSUploadDocument>(
  '/api/ordermsdocuments',
  'orderMSDocument'
)
